export default __webpack_public_path__ + "static/media/payNowRedirectIcon.70bbeaff.svg";